import { slash } from './slash.js';
/**
 * Normalize a path:
 * - If it's empty, undefined, or `.`, return `.`.
 * - If it's relative, normalize slashes and ensure it starts with `./`.
 * - If it starts with `/`, add a leading `.` (this is an absolute path but is sometimes treated
 *   as package-relative)
 * - If it's an absolute Windows path (starts with a drive letter), throw an error.
 * - If it's absolute, throw an error (since this likely indicates a bug in the calling code).
 *
 * Note that this will NOT remove a trailing slash (if present).
 */
export function normalizeRelativePath(originalPath) {
    if (!originalPath || originalPath === '.') {
        return '.';
    }
    // Throw on an absolute Windows path: this is definitely absolute regardless of the context it
    // came from, and if the calling code attempts to join it to another path as if it was relative,
    // that will have bad results. It's more likely on Windows that we could unintentionally end up
    // with an absolute path since there's no way to do relative paths across drive letters
    // (path.relative() will return an absolute path), so we throw here to make it clear that
    // Cloudpack needs to have specific handling for any cases where that might be possible.
    if (/^[a-zA-Z]:[\\/]/.test(originalPath)) {
        throw new Error(`Received an absolute path where a relative path was expected: ${originalPath}.\n` +
            'This indicates a bug in Cloudpack, likely due to calling path.relative() with two Windows paths ' +
            'on different drives (which returns an absolute path) and then assuming the result is relative.');
    }
    // Ensure we have the right slashes.
    const normalizedPath = slash(originalPath);
    if (normalizedPath[0] === '/') {
        // Technically a path starting with / is absolute, but it's possible that package.json
        // entry points like "main" could also use a leading slash to indicate the package root.
        return '.' + normalizedPath;
    }
    return /^\.\.?\//.test(normalizedPath) ? normalizedPath : `./${normalizedPath}`;
}
//# sourceMappingURL=normalizeRelativePath.js.map